module.exports = __webpack_public_path__ + "static/img/ccod7.60e659e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod7.png
// module id = ScSk
// module chunks = 0